import { Base } from '@studiometa/js-toolkit';

/**
 * HorizontalScroll class.
 */
export default class HorizontalScroll extends Base {
  /**
   * Config.
   */
  static config = {
    name: 'HorizontalScroll',
  };

  /**
   * Mounted hook.
   */
  mounted() {
    window.addEventListener('wheel', this);
    window.addEventListener('mousewheel', this);
  }

  /**
   * Destroyed hook.
   */
  destroyed() {
    window.removeEventListener('wheel', this);
    window.removeEventListener('mousewheel', this);
  }

  /**
   * Dispatch event.
   * @param   {Event} event
   */
  handleEvent(event) {
    if (event.type === 'wheel') {
      this.onWindowWheel(event);
    }
  }

  /**
   * Sync vertical and horizontal scroll.
   * @param   {WheelEvent} event
   * @returns {void}
   */
  onWindowWheel(event) {
    if (Math.abs(event.deltaY) > Math.abs(event.deltaX)) {
      document.scrollingElement.scrollLeft += event.deltaY;
    }

    if (Math.abs(event.deltaX) > Math.abs(event.deltaY)) {
      document.scrollingElement.scrollTop += event.deltaX;
    }
  }
}
